import { ReactNode } from 'react';

import TenantAccessIndicatorProviderContext from './context/tenant-access-indicator-provider-context';
import useTenantAccessIndicatorState from './states/tenant-access-indicator-states';

type Props = {
  children: ReactNode;
};

const TenantAccessIndicatorProvider = ({ children }: Props): React.JSX.Element => (
  <TenantAccessIndicatorProviderContext value={useTenantAccessIndicatorState()}>{children}</TenantAccessIndicatorProviderContext>
);

export default TenantAccessIndicatorProvider;
